export enum TRACKING_NAME {
  PAGE_OPENING = 'page_opening'
}
